module.exports = __webpack_public_path__ + "static/media/icon-heart-healthy.171b6f2b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/icons/icon-heart-healthy.svg
// module id = 692
// module chunks = 0